(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('live-config').textContent);
  const $ = s => document.querySelector(s), all = s => [...document.querySelectorAll(s)];
  const fmt = n => new Intl.NumberFormat(config.locale,{style:'currency',currency:config.currency}).format(n/100);
  let selected, busy=false, page=0, count=6;
  const initialReviews=all('[data-live-reviews] > .cc-review-card');
  initialReviews.slice(count).forEach(card=>card.hidden=true);
  if($('[data-live-review-status]'))$('[data-live-review-status]').textContent=count+' / 3448';
  if($('[data-live-more]'))$('[data-live-more]').textContent=config.strings.more;
  const toast = text => { const el=$('.cc-toast'); el.textContent=text; el.hidden=false; setTimeout(()=>el.hidden=true,5000); };
  const gallery=$('.cc-gallery-main'), photos=all('.cc-thumbs [data-image]'), lightbox=$('#campaign-lightbox');
  let photoIndex=Math.max(0,photos.findIndex(b=>b.classList.contains('is-active')));
  function showPhoto(index) {
    if(!photos.length)return;
    photoIndex=(index+photos.length)%photos.length;
    const button=photos[photoIndex], image=$('#campaign-main-image');
    image.src=button.dataset.image;image.removeAttribute('srcset');image.alt=button.dataset.caption||'';
    photos.forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});
    const strip=button.parentElement;
    strip.scrollTo({left:button.offsetLeft-strip.offsetLeft-(strip.clientWidth-button.offsetWidth)/2,behavior:'auto'});
    if(lightbox){
      const enlarged=lightbox.querySelector('[data-lightbox-image]');
      enlarged.src=button.dataset.image;enlarged.alt=image.alt;
      lightbox.querySelector('[data-lightbox-caption]').textContent=(photoIndex+1)+' / '+photos.length;
      lightbox.querySelector('#cc-lightbox-title').textContent=image.alt;
      lightbox.classList.remove('is-zoomed');
      lightbox.querySelector('[data-photo-zoom]').setAttribute('aria-pressed','false');
      lightbox.querySelector('.cc-lightbox-viewport').scrollTo(0,0);
    }
  }
  function openPhoto(){if(!lightbox||!photos.length)return;showPhoto(photoIndex);lightbox.showModal();}
  function swipe(surface) {
    let start,touchStart,swiped=false;
    const zoomed=()=>lightbox?.classList.contains('is-zoomed');
    function finish(dx,dy) {
      if(Math.abs(dx)>30&&Math.abs(dx)>Math.abs(dy)*1.2){showPhoto(photoIndex+(dx<0?1:-1));swiped=true;}
    }
    surface.addEventListener('dragstart',e=>e.preventDefault());
    // Touch events survive the pointercancel sent when a mobile browser
    // takes ownership of a gesture. Keep vertical scrolling and pinch zoom.
    surface.addEventListener('touchstart',e=>{
      swiped=false;touchStart=null;
      if(e.touches.length!==1||zoomed())return;
      const t=e.touches[0];touchStart={x:t.clientX,y:t.clientY,id:t.identifier,axis:null};
    },{passive:true});
    surface.addEventListener('touchmove',e=>{
      if(!touchStart)return;
      if(e.touches.length!==1||zoomed()){touchStart=null;return;}
      const t=e.touches[0],dx=t.clientX-touchStart.x,dy=t.clientY-touchStart.y;
      if(!touchStart.axis&&Math.max(Math.abs(dx),Math.abs(dy))>10)touchStart.axis=Math.abs(dx)>Math.abs(dy)*1.2?'x':'y';
      if(touchStart.axis==='x'&&e.cancelable)e.preventDefault();
    },{passive:false});
    surface.addEventListener('touchend',e=>{
      if(!touchStart)return;
      const origin=touchStart;touchStart=null;
      const t=[...e.changedTouches].find(t=>t.identifier===origin.id);
      if(t&&origin.axis!=='y'&&!zoomed())finish(t.clientX-origin.x,t.clientY-origin.y);
    },{passive:true});
    surface.addEventListener('touchcancel',()=>{touchStart=null;},{passive:true});
    surface.addEventListener('pointerdown',e=>{
      if(e.pointerType==='touch')return;
      swiped=false;
      if(!e.isPrimary||e.button!==0||zoomed())return;
      start={x:e.clientX,y:e.clientY,id:e.pointerId};surface.setPointerCapture(e.pointerId);
    });
    surface.addEventListener('pointerup',e=>{
      if(!start||e.pointerId!==start.id)return;
      const dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;
      finish(dx,dy);
    });
    surface.addEventListener('pointercancel',()=>{start=null;});
    surface.addEventListener('click',e=>{if(swiped){e.preventDefault();e.stopImmediatePropagation();swiped=false;}},true);
  }
  if(gallery&&photos.length){
    swipe(gallery);gallery.addEventListener('click',openPhoto);
    gallery.addEventListener('keydown',e=>{
      if(e.key==='Enter'||e.key===' '){e.preventDefault();openPhoto();}
      if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();showPhoto(photoIndex+(e.key==='ArrowRight'?1:-1));}
    });
  }
  if(lightbox){
    swipe(lightbox.querySelector('.cc-lightbox-viewport'));
    lightbox.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();showPhoto(photoIndex+(e.key==='ArrowRight'?1:-1));}});
    lightbox.addEventListener('click',e=>{if(e.target===lightbox)lightbox.close();});
  }
  let preparedPayment = null;
  async function showPaymentOptions() {
    const response = await fetch(config.root+'?section_id=campaign-express-cart', {cache:'no-store'});
    if (!response.ok) throw new Error(config.strings.error);
    const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
    const dialog = markup.querySelector('[data-payment-dialog]');
    if (!dialog) throw new Error(config.strings.error);
    $('[data-payment-dialog]')?.remove();
    document.body.append(dialog);
    dialog.showModal();
    dialog.addEventListener('click', event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
    const cartResponse = await fetch(config.root+'cart.js');
    if(cartResponse.ok){const cart=await cartResponse.json();all('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);}
  }
  function select(input) {
    if(!input || input.disabled) return;
    selected=input;
    all('[data-express-quantity]').forEach(el=>{el.value=input.dataset.kits;el.dispatchEvent(new Event('change',{bubbles:true}));});
    all('[data-bundles] input').forEach(el=>{el.checked=el.dataset.kits===input.dataset.kits;el.closest('.cc-bundle').classList.toggle('is-selected',el.checked);});
    all('[data-selected-price]').forEach(el=>el.textContent=fmt(Number(input.dataset.price)));
    all('[data-selected-label]').forEach(el=>el.textContent=input.dataset.kits+' '+(Number(input.dataset.kits)===1?config.strings.kit:config.strings.kits));
  }
  // History restoration can preserve the disabled buttons and in-flight flag
  // from the successful add that navigated to the cart.
  addEventListener('pageshow',event=>{
    if(!event.persisted)return;
    busy=false;
    select($('[data-bundles] input:checked:not(:disabled)')||$('[data-bundles] input:not(:disabled)'));
    all('[data-add]').forEach(button=>{button.disabled=!selected;button.removeAttribute('aria-busy');});
    fetch(config.root+'cart.js',{headers:{Accept:'application/json'}})
      .then(response=>response.ok?response.json():null)
      .then(cart=>{if(cart)all('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);})
      .catch(()=>{});
  });
  document.addEventListener('change',e=>{if(e.target.matches('[data-bundles] input')) select(e.target);});
  document.addEventListener('click',async e=>{
    const b=e.target.closest('button,a'); if(!b)return;
    if(b.matches('[data-payment-quantity]')) {
      if(busy)return;
      busy=true;
      const dialog=b.closest('[data-payment-dialog]');
      dialog.inert=true;
      dialog.setAttribute('aria-busy','true');
      try {
        const response=await fetch(config.root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:b.dataset.lineKey,quantity:Number(b.dataset.paymentQuantity)})});
        const cart=await response.json();
        if(!response.ok)throw new Error(cart.description||cart.message||config.strings.error);
        if(cart.item_count===0)preparedPayment=null;
        await showPaymentOptions();
      } catch(error) {toast(error.message||config.strings.error);}
      finally {busy=false;dialog.inert=false;dialog.removeAttribute('aria-busy');}
      return;
    }
    if(b.matches('[data-add]')) {
      if(busy)return; if(!selected){toast(config.strings.choose);return;} busy=true; all('[data-add]').forEach(el=>{el.disabled=true;el.setAttribute('aria-busy','true');});
      try {
        const selectionKey=selected.value+':'+selected.dataset.kits;
        if(preparedPayment!==selectionKey){
          const cartResponse=await fetch(config.root+'cart.js',{cache:'no-store'});
          if(!cartResponse.ok)throw new Error(config.strings.error);
          const cart=await cartResponse.json();
          const updates=Object.fromEntries(cart.items.map(item=>[item.key,0]));
          const existing=cart.items.find(item=>String(item.variant_id)===selected.value);
          updates[existing?existing.key:selected.value]=Number(selected.dataset.kits);
          // A newly chosen kit replaces the previous purchase selection, rather than adding to it.
          const response=await fetch(config.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
          const data=await response.json();if(!response.ok)throw new Error(data.description||config.strings.error);
          preparedPayment=selectionKey;
        }
        await showPaymentOptions();
      }
      catch(error){toast(error.message||config.strings.error);}
      finally{busy=false;all('[data-add]').forEach(el=>{el.disabled=false;el.removeAttribute('aria-busy');});}
    }
    if(b.matches('[data-open-cart]'))location.assign(config.cart);
    if(b.matches('[data-change-bundle]'))$('#bundles').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    if(b.matches('[data-image]'))showPhoto(photos.indexOf(b));
    if(b.matches('[data-close-dialog]'))b.closest('dialog').close();
    if(b.matches('[data-photo-prev]'))showPhoto(photoIndex-1);
    if(b.matches('[data-photo-next]'))showPhoto(photoIndex+1);
    if(b.matches('[data-photo-zoom]')){lightbox.classList.toggle('is-zoomed');b.setAttribute('aria-pressed',String(lightbox.classList.contains('is-zoomed')));}
    if(b.matches('[data-live-more]')) {
      const remaining=initialReviews.filter(card=>card.hidden);
      if(remaining.length){remaining.forEach(card=>card.hidden=false);count+=remaining.length;$('[data-live-review-status]').textContent=count+' / 3448';return;}
      b.disabled=true;
      try {
        const urls=JSON.parse($('#live-review-pages').textContent); const response=await fetch(urls[page]);if(!response.ok)throw Error();const rows=await response.json();
        const base=$('[data-review-asset-base]').dataset.reviewAssetBase;
        for(const row of rows){const card=document.createElement('article');card.className='cc-review-card';if(row.photo){const im=document.createElement('img');im.src=base.replace(/live-review-1001\.webp(?:\?.*)?$/,row.photo);im.alt=config.strings.customerPhoto||'Customer photo';im.width=600;im.height=600;im.loading='lazy';card.append(im);} const stars=document.createElement('p');stars.textContent='★'.repeat(row.rating)+'☆'.repeat(5-row.rating);const quote=document.createElement('blockquote');quote.textContent=row.text;const footer=document.createElement('footer');const name=document.createElement('strong');name.textContent=row.name;const verified=document.createElement('span');verified.textContent=config.strings.verified||'✓ Verified buyer';footer.append(name,verified);card.append(stars,quote,footer);$('[data-live-reviews]').append(card);}
        page++;count+=rows.length;$('[data-live-review-status]').textContent=count+' / 3448';b.hidden=page>=urls.length;b.textContent=config.strings.more;
      }catch{b.textContent=config.strings.retry;}finally{b.disabled=false;}
    }
    if(b.matches('[data-motion]')){document.body.classList.toggle('cc-paused');b.setAttribute('aria-pressed',String(document.body.classList.contains('cc-paused')));}
    if(b.matches('[data-video-toggle]')){videoPaused=!videoPaused;b.textContent=videoPaused?config.strings.play:config.strings.pause;all('[data-autoplay]').forEach(v=>{if(videoPaused)v.pause();else{loadVideo(v);v.play().catch(()=>{});}});}
  });
  let videoPaused=matchMedia('(prefers-reduced-motion: reduce)').matches||Boolean(navigator.connection?.saveData);
  function loadVideo(v){const s=v.querySelector('source');if(!s.getAttribute('src')){s.src=s.dataset.src;v.load();}}
  const observer=new IntersectionObserver(entries=>entries.forEach(({target:v,isIntersecting})=>{if(isIntersecting&&!videoPaused){loadVideo(v);v.play().catch(()=>{});}else v.pause();}),{threshold:.2});all('[data-autoplay]').forEach(v=>observer.observe(v));
  if(videoPaused&&$('[data-video-toggle]'))$('[data-video-toggle]').textContent=config.strings.play;
  const emphasisObserver=new IntersectionObserver(entries=>entries.forEach(entry=>entry.target.classList.toggle('cc-inview',entry.isIntersecting)),{threshold:.15});
  all('.cc-live-stats,.cc-live-comparison').forEach(el=>emphasisObserver.observe(el));
  let pending=false;
  function scroll(){pending=false;const sticky=$('.cc-sticky-buy');const primaryVisible=all('main [data-add]').some(b=>{const r=b.getBoundingClientRect();return r.top>80&&r.bottom<innerHeight-40;});if(sticky){sticky.hidden=scrollY<500||primaryVisible;document.body.style.setProperty('--cc-purchase-height',Math.max(80,sticky.getBoundingClientRect().height)+'px');}const bar=$('.cc-scroll-progress span');if(bar)bar.style.width=Math.min(100,100*scrollY/Math.max(1,document.documentElement.scrollHeight-innerHeight))+'%';const preview=$('#PBarNextFrameWrapper');document.body.style.setProperty('--cc-preview-offset',(preview?preview.getBoundingClientRect().height:0)+'px');}
  addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(scroll);}},{passive:true});addEventListener('resize',scroll);select($('[data-bundles] input:checked:not(:disabled)')||$('[data-bundles] input:not(:disabled)'));if(!selected)all('[data-add]').forEach(b=>{b.disabled=true;b.textContent=config.strings.unavailable;});scroll();
})();
